import themeVariables from "@Theme/exportColor.module.scss";

export default ({ fill = themeVariables.neutral5, width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_475_10049)">
      <path
        d="M3.95882 3.58352C5.64781 3.28698 7.77275 2.63246 9.34641 1.34784C9.53128 1.19692 9.7986 1.11194 10.0926 1.11387C10.3863 1.11581 10.6705 1.20474 10.8759 1.35592C12.2707 2.38288 14.4091 3.06905 16.1029 3.46037C16.9096 3.64677 17.5105 4.34012 17.5382 5.13954C17.6885 9.46774 17.8314 15.724 11.8274 18.835C10.7527 19.3918 9.45782 19.391 8.3824 18.8343C2.47558 15.7767 2.24596 9.63841 2.31455 5.35612C2.32839 4.49235 3.04275 3.74436 3.95882 3.58352Z"
        fill="white"
        stroke="#1F2A37"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M14.0617 9.75143C14.0617 12.0465 12.2439 13.8919 10.0199 13.8919C7.79594 13.8919 5.97813 12.0465 5.97813 9.75143C5.97813 7.45637 7.79594 5.61094 10.0199 5.61094C12.2439 5.61094 14.0617 7.45637 14.0617 9.75143Z"
        fill="#FDC8D3"
        stroke="#1F2A37"
        strokeWidth="0.8"
      />
      <path
        d="M8.10938 10.0139L8.63816 10.5482C9.02951 10.9437 9.66838 10.9437 10.0597 10.5482L11.9166 8.67188"
        stroke="#1F2A37"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_475_10049">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
